import { useEffect } from 'react';

import { useAuthQuery } from './useAuthQuery';

// Keep cross-tab session bookkeeping at the root, outside component subscriptions.
export const useAuthBootstrap = () => {
  const { user } = useAuthQuery();

  useEffect(() => {
    if (user?.slug && localStorage.getItem('user_logged_in') !== user.slug) {
      localStorage.setItem('user_logged_in', user.slug);
    }
  }, [user]);
};
